var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisbursementDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23436_53544)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23436_53544",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3335 0H0.333496V24H24.3335V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23436_53544)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0835 2.25V12.6193L6.73592 9.74992L6.07157 9.18052C5.91432 9.04567 5.73245 8.98628 5.52596 9.00218C5.31946 9.018 5.14882 9.10463 5.01404 9.26183C4.87925 9.4191 4.8198 9.60098 4.83569 9.80745C4.85157 10.0139 4.93814 10.1846 5.09539 10.3194L10.3329 14.8087C10.4733 14.9362 10.6402 15 10.8335 15C11.0271 15 11.1941 14.936 11.3347 14.8081L16.5716 10.3194C16.7288 10.1846 16.8154 10.0139 16.8312 9.80745C16.8471 9.60098 16.7877 9.4191 16.6529 9.26183C16.5181 9.10463 16.3475 9.018 16.141 9.00218C15.9345 8.98628 15.7526 9.04567 15.5954 9.18052L14.931 9.74992L11.5835 12.6193V2.25C11.5835 2.0429 11.5103 1.86612 11.3638 1.71967C11.2173 1.57322 11.0406 1.5 10.8335 1.5C10.6264 1.5 10.4496 1.57322 10.3032 1.71967C10.1567 1.86612 10.0835 2.0429 10.0835 2.25ZM4.83275 18.75H13.1317C13.281 19.8812 13.7775 20.8687 14.6212 21.7123C15.6463 22.7374 16.8837 23.25 18.3335 23.25C19.7832 23.25 21.0207 22.7374 22.0458 21.7123C23.0709 20.6872 23.5835 19.4498 23.5835 18C23.5835 16.5503 23.0709 15.3128 22.0458 14.2877C21.0207 13.2626 19.7832 12.75 18.3335 12.75C16.8837 12.75 15.6463 13.2626 14.6212 14.2877C13.7775 15.1313 13.281 16.1188 13.1317 17.25H4.83275C4.33325 17.25 4.0835 17.0002 4.0835 16.5007V15C4.0835 14.7929 4.01027 14.6161 3.86383 14.4697C3.71738 14.3232 3.5406 14.25 3.3335 14.25C3.12639 14.25 2.94962 14.3232 2.80316 14.4697C2.65672 14.6161 2.5835 14.7929 2.5835 15V16.5007C2.5835 18.0002 3.33325 18.75 4.83275 18.75ZM15.6819 20.6516C14.9496 19.9194 14.5835 19.0355 14.5835 18C14.5835 16.9645 14.9496 16.0806 15.6819 15.3484C16.4141 14.6161 17.298 14.25 18.3335 14.25C19.369 14.25 20.2529 14.6161 20.9851 15.3484C21.7173 16.0806 22.0835 16.9645 22.0835 18C22.0835 19.0355 21.7173 19.9194 20.9851 20.6516C20.2529 21.3839 19.369 21.75 18.3335 21.75C17.298 21.75 16.4141 21.3839 15.6819 20.6516ZM16.5952 17.7517L16.8529 17.9922L17.3692 18.4741L18.6599 17.2694L20.0718 15.9517C20.2231 15.8104 20.4024 15.7433 20.6093 15.7505C20.8163 15.7576 20.9904 15.8368 21.1317 15.9883C21.273 16.1396 21.3402 16.3189 21.333 16.5258C21.3259 16.7328 21.2466 16.907 21.0952 17.0483L17.8809 20.0483C17.7369 20.1827 17.5662 20.25 17.3692 20.25C17.1721 20.25 17.0015 20.1827 16.8574 20.0483L15.5718 18.8483C15.4203 18.707 15.3411 18.5328 15.3339 18.3258C15.3267 18.1189 15.3939 17.9396 15.5352 17.7883C15.6765 17.6368 15.8506 17.5576 16.0576 17.5504C16.2646 17.5433 16.4438 17.6104 16.5952 17.7517Z",
    fill: "#7D778C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23436_53544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisbursementDownload);
export default __webpack_public_path__ + "static/media/disbursementDownload.63c161cd362c5b0fe572340a2f29f4aa.svg";
export { ForwardRef as ReactComponent };